const UlAccords = {
  init(target) {
    const listItems = target.querySelectorAll('.ulaccord__item')

    if (listItems.length > 0) {
      listItems.forEach((item) => {
        item.addEventListener('change', (e) => this.changed(e, listItems))

        const currentInputElement = item.querySelector('input[type=radio]:checked')

        if (currentInputElement) {
          item.classList.add('ulaccord__item--open')
        }
      })
    }
  },
  changed(e, listItems) {
    if (!e.currentTarget.classList.contains('ulaccord__item--open')) {
      this.closeAll(listItems)
    }
    e.currentTarget.classList.add('ulaccord__item--open')
  },
  closeAll(listItems) {
    listItems.forEach((item) => {
      item.classList.remove('ulaccord__item--open')
    })
  },
}

export default UlAccords
